// src/components/LoggedInNav.js

import React, { useState } from 'react'; 
import { Link, useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import './LoggedInNav.css';

function LoggedInNav() {
  const navigate = useNavigate();
  // State to manage the mobile menu's visibility
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Function to toggle the menu state
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Function to close the mobile menu (used when a link is clicked)
  const closeMobileMenu = () => {
    setIsMenuOpen(false);
  };

  const handleLogout = async () => {
    try {
      await auth.signOut();
      closeMobileMenu(); // Close menu on logout
      navigate('/login');
    } catch (error) {
      console.error("Failed to log out:", error);
    }
  };

  const logoUrl = 'https://firebasestorage.googleapis.com/v0/b/steps4inclusiveai.firebasestorage.app/o/site-assets%2Frefugeai%2Frefugeai_logo01.jpg?alt=media&token=52a9fde1-198e-4cbb-a4e4-e116e2829bd2';

  return (
    <nav className="logged-in-navbar">
      <div className="navbar-container">
        <Link to="/dashboard" className="navbar-logo" onClick={closeMobileMenu}>
          <img src={logoUrl} alt="Inclusive Ai Logo" className="logo-image" />
        </Link>

        {/* Hamburger/Close Icon for mobile */}
        <div className="menu-icon" onClick={toggleMenu}>
          {isMenuOpen ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
          )}
        </div>

        {/* Menu - applies 'active' class when isMenuOpen is true */}
        <ul className={isMenuOpen ? 'nav-menu active' : 'nav-menu'}>
          <li className="nav-item">
            <Link to="/dashboard" className="nav-links" onClick={closeMobileMenu}>
              Dashboard
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/add-resources" className="nav-links" onClick={closeMobileMenu}>
              Add Pins
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/assessment" className="nav-links" onClick={closeMobileMenu}>
              Score
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/profile" className="nav-links" onClick={closeMobileMenu}>
              Profile
            </Link>
          </li>
          <li className="nav-item-button">
            <button onClick={handleLogout} className="nav-links-button">
              Log Out
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default LoggedInNav;